export default {
  computed: {
    salesRoutes() {
      return {
        sales: {
          title: "Vendas"
        },
        "sales-events": {
          title: "Eventos"
        },
        "sales-subscriptions": {
          title: "Assinaturas"
        },
        "sales-courses": {
          title: "Cursos"
        },
        "subscriptions-manager": {
          title: "Gestão de Assinaturas"
        },
        "sales-recovery": {
          title: "Recuperação de compras"
        }
      };
    }
  }
};
